import { MetricsDisabled, MetricsGrey, NullableStatus, ThresholdStatus } from '@tableau/metrics-engine';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { StatusDropdownComponent } from './StatusDropdownComponent';

export interface StatusComponentProps {
  readonly onStatusChange: (status: NullableStatus) => void;
  readonly status: NullableStatus;
  disabled?: boolean;
}

export const StatusComponent = (props: StatusComponentProps): JSX.Element => {
  const onAboveChange = (value: ThresholdStatus) => {
    props.onStatusChange({ ...props.status, above: value });
  };
  const onBelowChange = (value: ThresholdStatus) => {
    props.onStatusChange({ ...props.status, below: value });
  };
  const onAtChange = (value: ThresholdStatus) => {
    props.onStatusChange({ ...props.status, equal: value });
  };

  const color = props.disabled ? MetricsDisabled : MetricsGrey;

  return (
    <div>
      <p style={{ fontWeight: 'bold', marginTop: 0, color }}>{Messages.Status()}</p>
      <div style={{ marginLeft: 20 }}>
        <StatusDropdownComponent
          testId={'above-value-options'}
          label={Messages.AboveValue()}
          value={props.status.above}
          onChange={onAboveChange}
          disabled={props.disabled}
        />
        <StatusDropdownComponent
          testId={'at-value-options'}
          label={Messages.AtValue()}
          value={props.status.equal}
          onChange={onAtChange}
          disabled={props.disabled}
        />
        <StatusDropdownComponent
          testId={'below-value-options'}
          label={Messages.BelowValue()}
          value={props.status.below}
          onChange={onBelowChange}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};
